import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';

function Footer() {
    return (
        <AppBar className={'footer'} sx={{ backgroundColor: 'darkslategrey' }} position="sticky">
            <Container maxWidth="xl">
                <div className="footer-content">
                    <div className="footer-item">
                        <Typography variant="h5" component="h3">
                            Contact Us
                        </Typography>
                        <Typography variant="body2" gutterBottom className="info">
                            <AddIcCallIcon className="icon" />
                            <a href="tel:+37493929260">+374(93) 92 92 60</a>
                        </Typography>
                        <Typography variant="body2" gutterBottom className="info">
                            <EmailIcon className="icon" /> Info@voyagevibes.am
                        </Typography>
                    </div>
                    <div className="footer-item">
                        <Typography variant="h5" component="h3">
                            Follow Us!
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Your passport to unforgettable adventures 🌍✈️ | Travel tips, deals, & dreamy destinations.
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Follow for your next escape!
                        </Typography>
                        <Typography variant="body2" gutterBottom >
                            <a className="info" href="https://www.instagram.com/voyage_vibes_travel/" target="_blank"><InstagramIcon className="icon" /> Instagram</a>
                        </Typography>
                    </div>
                </div>
            </Container>
            <div>
                <Typography variant="body2" gutterBottom className="copyright">
                    Copyright © Voyage Vibes 2024-{new Date().getUTCFullYear()} | All rights reserved.
                </Typography>
            </div>
        </AppBar>
    );
}
export default Footer;
